import { uiOptions } from '@/config'
/**
 *
 * @param number
 */
export function formatNumberToLocaleNumber(number: number): string {
  return new Intl.NumberFormat(uiOptions().location.languageTag).format(Math.round(number * 10) / 10)
}
